import Image from 'next/image';
import awardBadge from '../../public/award-badge.svg';
import { RefundGuaranteeText } from './RefundGuaranteeText';

export function OverviewGuarantee({
  calloutType,
  refundableDays,
  isFree,
}: {
  calloutType: string;
  refundableDays: number;
  isFree: boolean;
}) {
  if (!calloutType) return null;

  return (
    <div className="inline-flex w-fit flex-row items-start rounded bg-blue-500/25 py-2 px-4">
      <Image src={awardBadge} width={22} alt="award-badge" />
      <div className="ml-2">
        <RefundGuaranteeText
          calloutType={calloutType}
          refundableDays={refundableDays}
          isFree={isFree}
        />
      </div>
    </div>
  );
}
